
import styled from 'styled-components'

import { UniiqueFeaturesList } from '../../helper/UniqueFeaturesList';

function UniqueFeatures() {

    return (
        <Wrapper>
            <section className='why'>
                <h3>Unique Features</h3>
                <div className="slider-container">
                    <div className="slider-track">
                        {/* Render images twice to create the seamless loop */}
                        {[...UniiqueFeaturesList[0].images, ...UniiqueFeaturesList[0].images].map((item, index) => (
                            <div className="slide" key={index}>
                                <img src={`/images/unique/${item}`} alt={`Slide ${index}`} />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </Wrapper>
    )
}
const Wrapper = styled.section`
.slider-container {
  overflow: hidden;
  width: 100%;
  background:${({ theme }) => theme.colors.footer_bg}; /* Matching your image background */
  padding: 20px 0;
}

.slider-track {
  display: flex;
  width: calc(250px * 20); /* (Width of slide * total slides) */
  animation: scroll 40s linear infinite;
}

.slider-track:hover {
  animation-play-state: paused; /* Pause on hover */
}

.slide {
  width: 400px;
  height: 300px;
  margin: 0 10px;
  flex-shrink: 0;
}

.slide img {
  width: 100%;
  height: 100%;
  object-fit: fit;
  border-radius: 8px;
  border: 4px solid white;
}

@keyframes scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(calc(-320px * 10)); } /* - (slide width + margin) * original count */
}
   
    h3{
        text-align:center;
        font-size:4rem;
        font-weight:500;
        margin-top:1rem;
    }
  

   
    @media (max-width: ${({ theme }) => theme.media.mobile}) {
               h3{
                font-size: 3.8rem;
               }
            .box{ 
               p{
                text-align: justify;
                font-size: 2.5rem;
                line-height: 1.2;
               }
            }
            img{
                width:100%;
            }
           
        }

`;
export default UniqueFeatures